import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const ProtectedRoute = () => {
    const isLoggedIn = useAuth();

    // If not authenticated, redirect to home (Coming Soon page)
    if (!isLoggedIn) {
        return <Navigate to="/" replace />;
    }

    // If authenticated, render the child route
    return <Outlet />;
};

export default ProtectedRoute;

